import { render } from "./accountOpeningProgress.vue?vue&type=template&id=0386fea2&scoped=true"
import script from "./accountOpeningProgress.vue?vue&type=script&lang=js"
export * from "./accountOpeningProgress.vue?vue&type=script&lang=js"

import "./accountOpeningProgress.vue?vue&type=style&index=0&id=0386fea2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0386fea2"

export default script